import { all, call, fork, put, takeEvery } from "redux-saga/effects";
import { API_GET } from "../../helpers/api";
import * as actions from "../actions/redemptions";
import {
  ACTIVE_REDEMPTIONS_SEARCH_REQUESTED,
  GET_CONSUMPTION_DATA_REQUESTED,
  HISTORY_REDEMPTIONS_SEARCH_REQUESTED,
} from "../types";

function* watchGetActiveRedemptions() {
  yield takeEvery(ACTIVE_REDEMPTIONS_SEARCH_REQUESTED, getActiveRedemptions);
}
function* watchGetHistoryRedemptions() {
  yield takeEvery(HISTORY_REDEMPTIONS_SEARCH_REQUESTED, getHistoryRedemptions);
}
function* watchGetConsumptionData() {
  yield takeEvery(GET_CONSUMPTION_DATA_REQUESTED, getConsumptionData);
}
function* getActiveRedemptions(action) {
  try {
    const res = yield call(apiGetActiveRedemptions, action.payload);

    let items = res.data.items.reduce((acc, value) => {
      let documentCount = value.redemptionDetails.reduce(
        (detailAcc, detailValue) => {
          detailAcc += detailValue.amount;
          return detailAcc;
        },
        0
      );
      acc.push({
        ...value,
        documentCount: documentCount,
        beneficiaryName: value.beneficiaryParty.title,
      });
      return acc;
    }, []);
    yield put(actions.activeRedemptionSearchSucceeded(items));
  } catch (err) {
    yield put(actions.activeRedemptionSearchFailed());
  }
}

function* getHistoryRedemptions(action) {
  try {
    const res = yield call(apiGetHistoryRedemptions, action.payload);
    let items = res.data.items.reduce((acc, value) => {
      let documentCount = value.redemptionDetails.reduce(
        (detailAcc, detailValue) => {
          detailAcc += detailValue.amount;
          return detailAcc;
        },
        0
      );
      acc.push({
        ...value,
        documentCount: documentCount,
        beneficiaryName: value.beneficiaryParty.title,
      });
      return acc;
    }, []);
    yield put(
      actions.historyRedemptionSearchSucceeded({
        items,
        total: {
          totalItemCount: res.data.totalItemCount,
          totalPageCount: res.data.totalPageCount,
        },
      })
    );
  } catch (err) {
    yield put(actions.historyRedemptionSearchFailed());
  }
}
function* getConsumptionData(action) {
  try {
    const res = yield call(apiGetConsumptionData, action.payload);
    let data = [];
    if (res.data.consumptionDataList.length > 0) {
      data = res.data.consumptionDataList.reduce(
        (acc, value) => {
          acc[0].consumptionPeriod = action.payload.period;
          acc[0].consumptionAmount += value.amount;
          acc[0].status = value.status;
          return acc;
        },
        [
          {
            consumptionPeriod: "",
            consumptionAmount: 0,
            status: "",
          },
        ]
      );
    }
    yield put(actions.getConsumptionDataSucceeded(data));
  } catch (err) {
    yield put(actions.getConsumptionDataFailed());
  }
}

export default function* redemptionSaga() {
  yield all([
    fork(watchGetActiveRedemptions),
    fork(watchGetHistoryRedemptions),
    fork(watchGetConsumptionData),
  ]);
}

function apiGetActiveRedemptions(filter) {
  return API_GET("certificate/redemption", {
    organizationId: filter.organizationId,
    title: filter.title ? filter.title : "",
    redemptionStatus: "INITIAL",
    consumptionStartYear: filter.startYear,
    consumptionStartMonth: filter.startMonth,
    consumptionEndYear: filter.endYear,
    consumptionEndMonth: filter.endMonth,
    page: 0,
    size: 1000,
  });
}

function apiGetHistoryRedemptions(reqParams) {
  return API_GET("certificate/redemption", {
    organizationId: reqParams.organizationId,
    title: reqParams.title,
    redemptionStatus: reqParams.status,
    consumptionStartYear: reqParams.startYear,
    consumptionStartMonth: reqParams.startMonth
      ? parseInt(reqParams.startMonth)
      : "",
    consumptionEndYear: reqParams.endYear,
    consumptionEndMonth: reqParams.endMonth ? parseInt(reqParams.endMonth) : "",
    page: reqParams?.page || 0,
    size: 10,
  });
}
function apiGetConsumptionData(filter) {
  let year = filter.period.split("-")[0];
  let month = filter.period.split("-")[1];
  return API_GET("consumption-data", {
    organizationId: filter.organizationId,
    term: filter.period ? `${year}${month}` : "",
    page: 0,
    size: 1000,
  });
}
